import { jsx as s } from "react/jsx-runtime";
import p from "clsx";
import '../_assets/SpinnerOverlay.CLU73SeO.css';const a = "_SpinnerOverlay_hropt_58", i = "_SpinnerOverlay_blur_hropt_67", y = "_SpinnerOverlay_absolute_hropt_70", h = "_SpinnerOverlay_opacity_25_hropt_78", g = "_SpinnerOverlay_opacity_50_hropt_82", w = "_SpinnerOverlay_opacity_75_hropt_86", u = "_SpinnerOverlay_opacity_100_hropt_90", b = "_Spinner_hropt_58", S = "_Spinner_absolute_hropt_100", d = "_Spinner_size_24_hropt_107", v = "_Spinner_size_32_hropt_111", O = "_Spinner_size_64_hropt_115", f = "_Spinner__Icon_hropt_119", k = "_spin_hropt_1", o = {
  SpinnerOverlay: a,
  SpinnerOverlay_blur: i,
  SpinnerOverlay_absolute: y,
  SpinnerOverlay_opacity_25: h,
  SpinnerOverlay_opacity_50: g,
  SpinnerOverlay_opacity_75: w,
  SpinnerOverlay_opacity_100: u,
  Spinner: b,
  Spinner_absolute: S,
  Spinner_size_24: d,
  Spinner_size_32: v,
  Spinner_size_64: O,
  Spinner__Icon: f,
  spin: k,
  "color_brand-green": "_color_brand-green_hropt_138",
  "color_brand-dark": "_color_brand-dark_hropt_141",
  "color_brand-white": "_color_brand-white_hropt_144",
  "color_orange-1": "_color_orange-1_hropt_147",
  "color_stone-1": "_color_stone-1_hropt_150",
  "color_green-1": "_color_green-1_hropt_153",
  "color_green-2": "_color_green-2_hropt_156",
  "color_green-3": "_color_green-3_hropt_159",
  "color_black-1": "_color_black-1_hropt_162",
  "color_black-2": "_color_black-2_hropt_165",
  "color_dark-2": "_color_dark-2_hropt_168",
  "color_grey-1": "_color_grey-1_hropt_171",
  "color_grey-2": "_color_grey-2_hropt_174",
  "color_grey-3": "_color_grey-3_hropt_177",
  "color_grey-4": "_color_grey-4_hropt_180",
  "color_grey-5": "_color_grey-5_hropt_183",
  "color_grey-6": "_color_grey-6_hropt_186",
  "color_grey-7": "_color_grey-7_hropt_189",
  "color_mint-1": "_color_mint-1_hropt_192",
  "color_mint-2": "_color_mint-2_hropt_195",
  "color_mint-3": "_color_mint-3_hropt_198",
  "color_secondary-grey-1": "_color_secondary-grey-1_hropt_201",
  "color_secondary-grey-4": "_color_secondary-grey-4_hropt_204",
  "color_secondary-grey-3": "_color_secondary-grey-3_hropt_207",
  "color_status-error": "_color_status-error_hropt_210",
  "color_status-error-bg": "_color_status-error-bg_hropt_213",
  "color_status-warning": "_color_status-warning_hropt_216",
  "color_status-warning-bg": "_color_status-warning-bg_hropt_219",
  "color_status-success": "_color_status-success_hropt_222",
  "color_status-success-bg": "_color_status-success-bg_hropt_225",
  "color_status-info": "_color_status-info_hropt_228",
  "color_status-info-bg": "_color_status-info-bg_hropt_231",
  "color_brand-green-new": "_color_brand-green-new_hropt_234",
  "color_brand-dark-new": "_color_brand-dark-new_hropt_237",
  "color_brand-white-new": "_color_brand-white-new_hropt_240",
  "color_brown-new": "_color_brown-new_hropt_243",
  "color_brown-hover-new": "_color_brown-hover-new_hropt_246",
  "color_stone-new": "_color_stone-new_hropt_249",
  "color_black-new": "_color_black-new_hropt_252",
  "color_red-1-new": "_color_red-1-new_hropt_255",
  "color_red-2-new": "_color_red-2-new_hropt_258",
  "color_red-stop-new": "_color_red-stop-new_hropt_261",
  "color_grey-1-new": "_color_grey-1-new_hropt_264",
  "color_dark-grey-1": "_color_dark-grey-1_hropt_267",
  "color_grey-2-new": "_color_grey-2-new_hropt_270",
  "color_grey-3-new": "_color_grey-3-new_hropt_273",
  "color_grey-4-new": "_color_grey-4-new_hropt_276",
  "color_grey-5-new": "_color_grey-5-new_hropt_279",
  "color_grey-6-new": "_color_grey-6-new_hropt_282",
  "color_grey-7-new": "_color_grey-7-new_hropt_285",
  "color_off-white": "_color_off-white_hropt_288",
  "color_status-error-new": "_color_status-error-new_hropt_291",
  "color_status-error-bg-new": "_color_status-error-bg-new_hropt_294",
  "color_status-warning-new": "_color_status-warning-new_hropt_297",
  "color_status-warning-bg-new": "_color_status-warning-bg-new_hropt_300",
  "color_status-success-new": "_color_status-success-new_hropt_303",
  "color_status-success-bg-new": "_color_status-success-bg-new_hropt_306",
  "color_status-info-new": "_color_status-info-new_hropt_309",
  "color_status-info-bg-new": "_color_status-info-bg-new_hropt_312",
  "color_secondary-grey-2": "_color_secondary-grey-2_hropt_315",
  "color_color-success-filied-default": "_color_color-success-filied-default_hropt_318",
  "slide-in-out": "_slide-in-out_hropt_1",
  "fade-in-out": "_fade-in-out_hropt_1"
}, x = (r) => {
  const { children: _, withOverlay: e, blur: n, absolute: t, opacity: c, className: l } = r;
  return e ? /* @__PURE__ */ s(
    "div",
    {
      className: p(
        o.SpinnerOverlay,
        n && o.SpinnerOverlay_blur,
        t && o.SpinnerOverlay_absolute,
        o[`SpinnerOverlay_opacity_${c}`],
        l
      ),
      children: _
    }
  ) : _;
};
export {
  x as S,
  o as s
};
